const ITEMS = [
  "Turkish Cotton",
  "Hand-Knotted Fringes",
  "OEM & Private Label",
  "Woven in Denizli",
  "OEKO-TEX Minded",
  "Made to be Kept",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="py-7 border-b border-line overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-serif italic text-2xl sm:text-3xl text-clay">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-ink/25" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
